/**
 * Porta l'elemento a fuoco dentro lo schermo, dove il runtime sa farlo.
 *
 * ## Perché serve
 *
 * Il cursore delle schermate on demand è un **indice**, non il fuoco del browser: nessuno scorre da
 * sé. Una fascia più larga dello schermo lascerebbe il cursore su una locandina che non si vede, e la
 * navigazione diventerebbe indovinare.
 *
 * `block: 'nearest'` scorre il minimo necessario: con `center` la vetrina salterebbe a ogni passo
 * laterale, che a tre metri si legge come un difetto.
 *
 * ## Perché è una funzione e non una riga
 *
 * Perché `scrollIntoView` **non c'è sempre**. Non è teoria da compatibilità: jsdom non lo implementa,
 * quindi la riga scritta direttamente faceva fallire nove prove del DOM con un `TypeError` — e lo
 * stesso `TypeError` su un runtime che non lo avesse butterebbe giù il disegno dell'intera schermata
 * per uno **scorrimento**, che è la cosa meno importante che ci sia lì dentro.
 *
 * Non è un ripiego silenzioso: non c'è niente da sostituire. Dove il metodo manca, la schermata resta
 * usabile e non scorre; dove c'è, scorre. La differenza fra le due cose non è un'informazione che
 * qualcuno debba ricevere.
 */
export function scrollFocusedIntoView(element: HTMLElement | null | undefined): void {
  if (!element || typeof element.scrollIntoView !== 'function') return;
  element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
